import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Spin, Checkbox } from "antd";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { has, filter } from "lodash";
import * as turf from "@turf/turf";
import socketIOClient from "socket.io-client";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

import "./ZonesDetails.scss";
import { MapboxMain } from "components/Mapbox";
import {
  ArrowIcon,
  LocationCenterIcon,
  EditIcon,
  DownloadIcon,
} from "components/Icons";
import { doDetailZone, doReGeocodeZone } from "modules/zone/stores/thunk";
import { updateLocationInsideZone } from "modules/zone/stores/slice";

const socketURI = process.env.REACT_APP_SOCKET_URI || "";
const socket = socketIOClient(socketURI);

const ZonesDetailsPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [menuSelecled, setMenuSelecled] = useState("addresses");
  const [locationClicked, setLocationClicked] = useState();
  const [subZoneClicked, setSubZoneClicked] = useState();
  const { isFetching, item: zone } = useSelector((state) => state.zone);
  const locationUpdated = useSelector((state) => state.location.locationUpdated);
  const [locations, setLocations] = useState([]);
  const [circle, setCircle] = useState();
  const [line, setLine] = useState();
  const [subZonesChecked, setSubZonesChecked] = useState([]);
  const [stopsInNewZones, setStopsInNewZones] = useState();
  const [isConfirmedAddress, setIsConfirmedAddress] = useState(false);
  const [isGeocode, setIsGeocode] = useState(false);

  const auth = useSelector((state) => state.auth);
  const user = auth.userData;


  useEffect(() => {
    socket.connect();
    socket.on(user?.sub, (data) => {
      if (data.event === "locations.geocoding.completed" && id) {
        setIsGeocode(false);
        dispatch(doDetailZone(id));
      }
    });
    return () => {
      socket.disconnect();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(doDetailZone(id));
    // eslint-disable-next-line
  }, []);

  const renderData = () => {
    updateLocations(zone.subZones);
    setSubZonesChecked(zone.subZones);
  }

  useEffect(() => {
    if (zone) {
      renderData()
    }
    // eslint-disable-next-line
  }, [zone, menuSelecled]);

  useEffect(() => {
    if (zone) {
      updateLocations(subZonesChecked);
    }
    // eslint-disable-next-line
  }, [subZonesChecked]);

  useEffect(() => {
    if (locationUpdated?.zone && locationUpdated?.zone === zone?._id) {
      updateZoneAfterUpdateLocation()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationUpdated])

  const updateLocations = (subZones) => {
    const locationsT = [
      {
        _id: zone._id,
        orderNo: 0,
        type: "zone",
        ptsWithin: true,
        address: zone.centerAddress,
        lat: zone.centerLat,
        lng: zone.centerLng,
        color: "FFC444",
      },
    ];
    const radius = zone.distanceRadius;
    const center = [zone.centerLng, zone.centerLat];
    const options = { steps: 500, units: "kilometers" };
    const circleT = turf.circle(center, radius, options);
    const lineT = turf.lineString(...circleT.geometry.coordinates);
    const polygon = turf.polygon([...circleT.geometry.coordinates]);
    for (let index = 0; index < zone.locations.length; index++) {
      const s = zone.locations[index];
      const locationT = {
        ...s,
        type: "location",
        orderNo: index + 1,
        hasAlternativeLocations: !!s.alternativeLocations?.length,
      };
      if (s.lat) {
        locationT.color = locationT.updatedInZone ? "00C853" : "FFC444";
        locationT.circleColor = locationT.updatedInZone ? "00C853" : "888888";
        locationT.circleBackgroundColor = locationT.updatedInZone
          ? "dff3e7"
          : "8883";
        const point = turf.point([s.lng, s.lat]);
        const ptsWithin = turf.booleanPointInPolygon(point, polygon);
        locationT.ptsWithin = ptsWithin;
        if (!ptsWithin) {
          locationT.color = "E53935";
        }
        if (menuSelecled === "sub-zones") {
          zone.subZones.forEach((subZone) => {
            const polygonSub = turf.polygon([subZone.points]);
            if (turf.booleanPointInPolygon(point, polygonSub)) {
              locationT.subZone = subZone;
              if (subZones.includes(subZone)) {
                locationT.color = subZone.color || "FFC444";
              }
            }
          });
        }
      } else {
        locationT.lat = 60.02463222202818;
        locationT.lng = 19.460256516522698;
        locationT.color = locationT.geocoding ? "d9d9d9" : "E53935";
        locationT.noLatLng = true;
      }
      locationsT.push(locationT);
    }
    setCircle(circleT);
    setLine(lineT);
    setLocations(locationsT);
  };

  const getLocationData = (location) => {
    const data = {
      Address: location.address,
      Latitude: location.lat,
      Longitude: location.lng,
      "Property Designation": location.propertyDesignation,
      "Real Estate Listing": location.realEstateListing,
      "Work Order Flag": location.workOrderFlag,
      "Registration Number": location.registrationNumber,
      "Free Text Field 1": location.freeTextField1,
      "Free Text Field 2": location.freeTextField2,
      Adjusted: location.updatedInZone ? "Y" : "N",
    };
    return data;
  };

  const handleDownloadSubzones = () => {
    const subZonesData = [];
    subZonesChecked.forEach((subZone) => {
      if (subZone.startAddress) {
        subZonesData.push({
          "SubZone Name": subZone.name,
          Address: subZone.startAddress,
          Latitude: subZone.startLat,
          Longitude: subZone.startLng,
          Type: "start",
        });
      }
      if (subZone.endAddress) {
        subZonesData.push({
          "SubZone Name": subZone.name,
          Address: subZone.endAddress,
          Latitude: subZone.endLat,
          Longitude: subZone.endLng,
          Type: "end",
        });
      }
      locations.forEach((location) => {
        if (location.subZone === subZone) {
          subZonesData.push({
            "SubZone Name": subZone.name,
            ...getLocationData(location),
          });
        }
      });
    });
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const wsSolution = XLSX.utils.json_to_sheet(subZonesData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsSolution, "SubZones");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, `SubZones-${Date.now()}` + fileExtension);
  };

  const updateZoneAfterUpdateLocation = async () => {
    await dispatch(updateLocationInsideZone({zone, locationUpdated }));
  }

  const handleDownloadLocations = () => {
    const locationsData = locations.map((location) =>
      getLocationData(location)
    );
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const wsSolution = XLSX.utils.json_to_sheet(locationsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsSolution, "SubZones");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, `Locations-${Date.now()}` + fileExtension);
  };

  const onChangeCheckbox = (e, item) => {
    const subZonesCheckedT = [...subZonesChecked];
    if (e.target.checked) {
      subZonesCheckedT.push(item);
    } else {
      const index = subZonesCheckedT.indexOf(item);
      subZonesCheckedT.splice(index, 1);
    }
    setSubZonesChecked(subZonesCheckedT);
  };

  const handleClickReGeocode = () => {
    setIsGeocode(true);
    dispatch(doReGeocodeZone(zone._id))
  }

  const handleOpenConfirmAddress = (location) => {
    setLocationClicked(location);
    setIsConfirmedAddress(true);
  };

  if (!zone) return <Spin style={{ paddingTop: 100, width: "100%" }} />;
  if (zone._id !== id)
    return <Spin style={{ paddingTop: 100, width: "100%" }} />;
  const isExist = has(zone.locations, (l) => !l.lat || !l.lng);
  if (isExist) return <Spin style={{ paddingTop: 100, width: "100%" }} />;
  const hasGeocode = !!locations.find(l => l.lat === 60.02463222202818 && l.lng === 19.460256516522698)

  return (
    <Spin spinning={isFetching || isGeocode}>
      <div className="Content ZonesDetailsPage">
        <MapboxMain
          zone={zone}
          circle={circle}
          setStopsInNewZones={setStopsInNewZones}
          stopsInNewZones={stopsInNewZones}
          line={line}
          locations={locations}
          locationClicked={locationClicked}
          setLocationClicked={setLocationClicked}
          subZoneClicked={subZoneClicked}
          setSubZoneClicked={setSubZoneClicked}
          menuSelecled={menuSelecled}
          subZonesChecked={subZonesChecked}
          isConfirmedAddress={isConfirmedAddress}
          onSetIsConfirmedAddress={setIsConfirmedAddress}
        />
        <div className="Breadcrumb">
          <Link to="/zones">Zoner</Link>
          <ArrowIcon />
          <span>{zone?.name}</span>
        </div>
        <div className="AddressesSubZones">
          <div className="AddressesSubZones__Menu">
            <Button
              className={`btn-addresses ${
                menuSelecled === "addresses" && "active"
              }`}
              onClick={() => setMenuSelecled("addresses")}
            >
              Adresser
            </Button>
            <Button
              className={`btn-sub-zones ${
                menuSelecled === "sub-zones" && "active"
              }`}
              onClick={() => setMenuSelecled("sub-zones")}
            >
              Del zoner
            </Button>
          </div>
          <div className="AddressesSubZones__Content">
            {menuSelecled === "addresses" && (
              <div className="Addresses">
                <div className="Title">
                  <div className="Left">Adresser</div>
                  <div className="Right">
                    {!!hasGeocode && <Button
                      className="btn-export"
                      onClick={handleClickReGeocode}
                    >
                      Geokod 
                    </Button>}
                    <Button
                      className="btn-export"
                      onClick={handleDownloadLocations}
                    >
                      Exportera
                      <DownloadIcon />
                    </Button>
                  </div>
                </div>
                <div className="ListAddresses">
                  {locations.map((location) => (
                    <div
                      key={location.orderNo}
                      className={`Item ${
                        locationClicked?._id === location._id && "selecled"
                      }`}
                    >
                      <div className="Name">
                        <div
                          className="Icon"
                          style={{
                            border: `1px solid #${location.color}`,
                            color: `#${location.color}`,
                          }}
                        >
                          {location.orderNo === 0 ? (
                            <LocationCenterIcon />
                          ) : (
                            location.orderNo
                          )}
                        </div>
                        {location.hasAlternativeLocations && (
                          <Button
                            type="text"
                            className="circle-box"
                            style={{
                              padding: 0,
                              color: `#${location.circleColor}`,
                              backgroundColor: `#${location.circleBackgroundColor}`,
                            }}
                            onClick={() => handleOpenConfirmAddress(location)}
                          >
                            ?
                          </Button>
                        )}
                        {location.address}
                      </div>
                      <div
                        className="Edit"
                        onClick={() => {
                          setLocationClicked(location);
                          setIsConfirmedAddress(false);
                        }}
                      >
                        <EditIcon />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {menuSelecled === "sub-zones" && (
              <div className="SubZones">
                <div className="Title">
                  <div className="Left">Del zoner</div>
                  <div className="Right">
                    <Button
                      disabled={!subZonesChecked.length}
                      className="btn-export"
                      onClick={handleDownloadSubzones}
                    >
                      Exportera
                      <DownloadIcon />
                    </Button>
                  </div>
                </div>
                <div className="ListAddresses">
                  {zone.subZones.map((subZone, index) => (
                    <div
                      key={index}
                      className={`Item ${
                        subZoneClicked?._id === subZone._id && "selecled"
                      }`}
                    >
                      <div className="Name">
                        <Checkbox
                          checked={subZonesChecked.includes(subZone)}
                          onChange={(e) => onChangeCheckbox(e, subZone)}
                        />
                        <span
                          style={{
                            width: "24px",
                            height: "24px",
                            background: `#${subZone.color}`,
                            marginRight: "4px",
                            marginLeft: "4px",
                          }}
                        />{" "}
                        {subZone.name} (
                        {filter(locations, (l) => l.subZone === subZone).length}{" "}
                        stops)
                      </div>
                      <div
                        className="Edit"
                        onClick={() => setSubZoneClicked(subZone)}
                      >
                        <EditIcon />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ZonesDetailsPage;
